import React from 'react';
import Card from './Card';

interface GameTableProps {
  playerHand: number[];
  dealerHand: number[];
  playerScore: number;
  dealerScore: number;
  result: string | null;
  gameActive: boolean;
  showDealerSecondCard?: boolean;
  winAmount?: number;
}

export default function GameTable({
  playerHand,
  dealerHand,
  playerScore,
  dealerScore,
  result,
  gameActive,
  showDealerSecondCard = false,
  winAmount = 0,
}: GameTableProps) {
  return (
    <div className="relative w-full h-full flex flex-col justify-between">
      {/* Dealer Area - Top */}
      <div className="text-center">
        <p className="text-green-200 text-xs md:text-sm font-semibold mb-2 md:mb-4">DEALER'S HAND</p>
        <div className="flex gap-3 md:gap-8 items-start justify-center mb-2 md:mb-4 h-32 md:h-48">
          {dealerHand.length > 0 && (
            <div className="card-deal">
              <Card value={dealerHand[0]} size="mobile" />
            </div>
          )}
          {dealerHand.length > 1 && (
            <div className="card-deal" style={{ animationDelay: '400ms' }}>
              {showDealerSecondCard ? (
                <Card value={dealerHand[1]} size="mobile" />
              ) : (
                <div className="w-16 h-24 md:w-24 md:h-36 bg-gradient-to-br from-red-600 to-red-800 rounded-lg border-2 border-red-700 shadow-lg flex items-center justify-center">
                  <div className="text-red-400 text-2xl md:text-4xl">🂠</div>
                </div>
              )}
            </div>
          )}
        </div>
        {dealerHand.length > 0 && showDealerSecondCard && (
          <p className="text-yellow-400 text-xs md:text-sm font-bold">{dealerScore}</p>
        )}
      </div>

      {/* Result Display */}
      {result && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm rounded-2xl">
          <div className="text-center px-4">
            <p className="text-3xl md:text-5xl font-bold text-white mb-2">
              {result === 'win' && 'YOU WIN!'}
              {result === 'lose' && 'YOU LOSE'}
              {result === 'push' && 'PUSH'}
              {result === 'bust' && 'BUST!'}
            </p>
            {(result === 'win' || result === 'push') && <p className="text-lg md:text-2xl text-yellow-300 font-bold">+${winAmount.toLocaleString()}</p>}
          </div>
        </div>
      )}

      {/* Player Area - Bottom */}
      <div className="text-center">
        <p className="text-green-200 text-xs md:text-sm font-semibold mb-2 md:mb-4">YOUR HAND</p>
        <div className="flex gap-3 md:gap-8 items-center justify-center flex-wrap h-auto md:h-48">
          {playerHand.map((card, i) => (
            <div key={i} className="card-deal" style={{ animationDelay: `${i * 200}ms` }}>
              <Card value={card} size="mobile" />
            </div>
          ))}
        </div>
        {playerHand.length > 0 && (
          <p className="text-yellow-400 text-xs md:text-sm font-bold mt-2">{playerScore}</p>
        )}
      </div>
    </div>
  );
}